import React, { useState } from "react";
import { NavigationLinks, Section, Text } from "../../../../components";
import {
  AlertaParaSaberMais,
  Banner,
  CondicoesGeraisCards,
} from "../../sections";

import { ReactComponent as ImageNavigationLinks } from "../../../../assets/images/habitacional/ilustracao-casa-habitacional.svg";

const DESCRIPTION_DEFAULT =
  "Entenda mais sobre o seu produto consultando as condições gerais. Confira!";

const CondicoesGeraisPage = () => {
  const [bannerDescription, setBannerDescription] = useState(
    DESCRIPTION_DEFAULT
  );
  return (
    <>
      <Banner
        sectionName="Banner da página de condições gerais"
        descricao={<Text>{bannerDescription}</Text>}
        contentWidth={{
          lg: 12,
          xl: 12,
        }}
      />
      {bannerDescription === DESCRIPTION_DEFAULT && (
        <Section
          as={AlertaParaSaberMais}
          sectionName="Alerta para saber mais sobre o produto"
        />
      )}
      <Section
        as={CondicoesGeraisCards}
        onProductSelected={setBannerDescription}
        sectionName="Cards de condições gerais dos seguros habitacionais"
      />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        image={<ImageNavigationLinks />}
      />
    </>
  );
};

CondicoesGeraisPage.propTypes = {};

export default CondicoesGeraisPage;
